module.exports = __webpack_public_path__ + "static/media/fa-regular-400.8af1e57e.woff";